module.exports = __webpack_public_path__ + "img/84ne.a8fb5eb1.svg";